
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/ev-software",
      function () {
        return require("private-next-pages/evcharging/ev-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/ev-software"])
      });
    }
  